import { useState, useEffect } from 'react';
import quarkusApi from '../../api/quarkusApi';

export function usePublicAppointmentConfirmation(token) {
  const [isLoading, setLoading] = useState(true);
  const [status, setStatus] = useState('');

  useEffect(() => {
    setLoading(true);
    quarkusApi
      .post('/public/confirm-appointment', null, { params: { token } })
      .then((returnFromApi) => {
        if (returnFromApi.status === 200) {
          setStatus('CONFIRMED');
        }
      })
      .catch((returnFromApi) => {
        console.error('ops! ocorreu um erro' + returnFromApi);
        setStatus('ERROR');
      })
      .finally(() => setLoading(false));
  }, [token]);

  return { status, isLoading };
}
